import 'zzc-analytics';
import Detector from '../../utils/detector';

let ua = navigator.userAgent.toLowerCase();

export default function InitConfig() {
  let zaPlatformsConfig = [{
    id: 'baidu',
    loader: function (cb) {
      za.getScript('https://hm.baidu.com/hm.js?01cfb5239f98ab6e8438e61e9ca0779d', function () {
        cb();
      });
    },
    sendEvent: function (category, action, label, value) {
      let eventParam = ['_trackEvent'];
      category && eventParam.push(category);
      action && eventParam.push(action);
      label && eventParam.push(label);
      value && eventParam.push(value);
      window._hmt && window._hmt.push(eventParam);
    }
  }, {
    id: 'ga',
    loader: function (cb) {
      za.getScript('https://www.googletagmanager.com/gtag/js?id=UA-88107304-7', function () {
        cb();
      });
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', 'UA-88107304-7');
    },
    sendEvent: function (category, action, label, value) {
      let eventParam = {event_category: category};
      if (action) {
        eventParam.event_action = action;
      }
      if (label) {
        eventParam.event_label = label;
      }
      if (value) {
        eventParam.value = value;
      }
      window.gtag('event', category, eventParam);
    }
  }];
  if (Detector.browser.tantutravel) {
    zaPlatformsConfig.push({
      id: 'mta',
      loader: function (cb) {
        za.getScript('https://pingjs.qq.com/mta/app_link_h5_stats.js', function () {
          window.MtaLinkH5.pageBasicStats({
            'title': window.location.href
          });
          cb();
        }, {
          name: 'MtaLinkH5', version: '1'
        });
      },
      sendEvent: function (category, action, label, value) {
        let separator = za('config', 'statementSeparator');
        let eventParam = [];
        category && eventParam.push(category);
        action && eventParam.push(action);
        label && eventParam.push(label);
        value && eventParam.push(value);
        eventParam.length && window.MtaLinkH5.eventStats(eventParam.join(separator));
      }
    });
  } else {
    zaPlatformsConfig.push({
      id: 'mta',
      loader: function (cb) {
        window._mtac = {'performanceMonitor': 1, 'senseQuery': 1};
        za.getScript('https://pingjs.qq.com/h5/stats.js?v2.0.4', function () {
          cb();
        }, {
          name: 'MTAH5', sid: '500528707', cid: '500532764'
        });
      },
      sendEvent: function (category, action, label, value) {
        let separator = za('config', 'statementSeparator');
        let eventParam = [];
        category && eventParam.push(category);
        action && eventParam.push(action);
        label && eventParam.push(label);
        value && eventParam.push(value);
        (eventParam.length && window.MtaH5) && window.MtaH5.clickStat(eventParam.join(separator));
      }
    });
  }

  let domain = document.domain;
  let subDomainArr = domain.split('.').slice(0, -2);
  let subDomainStr = subDomainArr.join('.');
  if (/^[a-z0-9.]+$/.test(subDomainStr) && ua.indexOf('(v1.0.0)') === -1) {
    za('platforms', zaPlatformsConfig);
  }
}



// WEBPACK FOOTER //
// ./src/components/statistics/config.js